@if (isLoading) {
<p>Loading doc cases...</p>
} @else if (docCases.length === 0) {
<p>No doc cases found.</p>
} @else {
    <div class="mt-3 listDocumentsFed">
        <h5 class="mb-3 fw-bold">Choose the type of federal document you need apostilled:</h5>
        <div class="corp-table">
            <div class="bg-white rounded-3 overflow-hidden">
                <div class="row m-0">
                    <!-- Case A -->
                    <div class="col-md-6 p-0 border-end case-a">
                        <div class="px-3 border-bottom case-title">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="fs-4">Case <span style="color: #fff; font-size: 26px">A</span></div>
                                <div class="casePrice">
                                    @if (totalFee !== null) {
                                        ${{ totalFee }} <small>+%5</small>
                                    } @else {
                                        $77 <small>+%5</small>
                                    }
                                </div>
                                <div class="fs-4" style="color: red">
                                    @if (totalTime !== null) {
                                        {{ totalTime }}B.D.
                                    } @else {
                                        11B.D.
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="p-3 border-bottom case-a-desc text-center" style="min-height: 80px;">
                            <div class="lookAsLabel" (click)="showCaseContent($event.currentTarget)">
                                Accepted as a digital document.
                                <i class="fa-solid fa-circle-down"></i>
                            </div>
                        </div>
                        <div class="p-3 case-content-select">
                            @for (doc of fdaDocsAcceptDigital; track doc.id) {
                            <div class="form-check d-flex align-items-center">
                                <div class="d-flex align-items-center checkboxContainer">
                                    <input class="form-check-input me-2" type="checkbox" name="{{doc.id}}" id="{{doc.id}}"
                                        value="{{doc.name}}" [checked]="orderSelection.getQuantity(doc.id) > 0"
                                        (change)="onCheckboxChange(doc, $event)" [disabled]="orderSelection.showOrderProcess()">
                                    <label class="form-check-label" for="{{doc.id}}">
                                        {{doc.name}}
                                        @if(doc.note){
                                        <br>
                                        <span class="small">{{doc.note}}</span>
                                        }
                                    </label>
                                </div>
                                @if (orderSelection.getQuantity(doc.id) > 0) {
                                <div class="plusMinsContainer" style="display: flex;">
                                    <button class="mins-btn" (click)="decrement(doc)" [disabled]="orderSelection.showOrderProcess()">
                                        <span class="material-symbols-outlined">
                                            remove
                                        </span>
                                    </button>
                                    <input type="text" class="form-control documentValue text-primary"
                                        [value]="orderSelection.getQuantity(doc.id)" readonly>
                                    <button class="plus-btn" (click)="increment(doc)" [disabled]="orderSelection.showOrderProcess()">
                                        <span class="material-symbols-outlined">
                                            add
                                        </span>
                                    </button>
                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>

                    <!-- Case B -->
                    <div class="col-md-6 p-0 case-b">
                        <div class="px-3 border-bottom case-title">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="fs-4">Case <span style="color: #fff; font-size: 26px">B</span></div>
                                <div class="casePrice">
                                    @if (totalFee !== null) {
                                        ${{ totalFee }} <small>+%5</small>
                                    } @else {
                                        $77 <small>+%5</small>
                                    }
                                </div>
                                <div class="fs-4" style="color: red">
                                    @if (totalTime !== null) {
                                        {{ totalTime }}B.D.
                                    } @else {
                                        11B.D.
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="p-3 border-bottom case-b-desc text-center" style="min-height: 80px;">
                            <div class="lookAsLabel" (click)="showCaseContent($event.currentTarget)">
                                <div>
                                    <span style="color: yellow;">Not</span> accepted as a
                                    digital document.
                                </div>
                                <i class="fa-solid fa-circle-down"></i>
                            </div>
                        </div>
                        <div class="p-3 case-content-select">
                            @for (doc of fdaDocsNotAccept; track $index) {
                            <div class="form-check d-flex align-items-center">
                                <div class="d-flex align-items-center checkboxContainer">
                                    <input class="form-check-input me-2" type="checkbox" name="{{doc.id}}" id="{{doc.id}}"
                                        value="{{doc.name}}" [checked]="orderSelection.getQuantity(doc.id) > 0"
                                        (change)="onCheckboxChange(doc, $event)" [disabled]="orderSelection.showOrderProcess()">
                                    <label class="form-check-label" for="{{doc.id}}">
                                        {{doc.name}}
                                        @if(doc.note){
                                        <br>
                                        <span class="small">{{doc.note}}</span>
                                        }
                                    </label>
                                </div>
                                @if (orderSelection.getQuantity(doc.id) > 0) {
                                <div class="plusMinsContainer" style="display: flex;">
                                    <button class="mins-btn" (click)="decrement(doc)" [disabled]="orderSelection.showOrderProcess()">
                                        <span class="material-symbols-outlined">
                                            remove
                                        </span>
                                    </button>
                                    <input type="text" class="form-control documentValue text-primary"
                                        [value]="orderSelection.getQuantity(doc.id)" readonly>
                                    <button class="plus-btn" (click)="increment(doc)" [disabled]="orderSelection.showOrderProcess()">
                                        <span class="material-symbols-outlined">
                                            add
                                        </span>
                                    </button>
                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

}